import { createContext } from 'react';

const playerContext = createContext();

export default playerContext;